import { COUNT_PLAIN_USER_ERROR, COUNT_PLAIN_USER_SUCCESS, COUNT_PLAIN_USER_POST_ERROR } from "../actions/types";

export default (state = { error: "", success: "", isSwitchSnackbarOn: false }, action) => {
    switch (action.type) {
        case COUNT_PLAIN_USER_ERROR:
            return {
                ...state,
                error: "testing here",
                success: state.success,
            };
        case COUNT_PLAIN_USER_SUCCESS:
            return {
                ...state,
                error: state.error,
                success: action.payload,
                count: action.count,
            };
        case COUNT_PLAIN_USER_POST_ERROR:
            return {
                ...state,
                error: state.error,
                success: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/countPlainUserReducer.js